import React, { useEffect } from 'react'
import {
  Input,
  InputRef,
  ButtonSecondary,
  FormDashboardInputPassword as InputPassword,
  AlertError,
} from '../../../components'
import { useHistory } from 'react-router-dom'
import { formUpdater, useViewport } from '../../../utils'
import accountService from '../../../features/account/service'
import debounce from 'lodash.debounce'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { setPopupContent } from '../../../features/account/slice'
import { useRef } from 'react'
const { createAccount } = accountService

const Form = ({className, noRedirect, embed, onClose}) => {
  const nameField = useRef(null)
  const dispatch = useDispatch()
  const [form, setForm] = React.useState({})
  const { isMobile } = useViewport()
  const history = useHistory()
  const [errorMessage, setErrorMessage] = React.useState(null)
  const [requesting, setRequesting] = React.useState(false)
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  // Browser auto-fill handling
  useEffect(() => {
    let interval = setInterval(() => {
      if (nameField.current && !form.name) {
        setForm({...form, name: nameField.current.value})
        clearInterval(interval)
      }
    }, 100)
  }, [form, nameField])

  const updateForm = debounce((e) => {
    formUpdater(e, form, setForm)
  }, 250)

  const validateForm = () => {
    if(!form.password || (form.password && form.password.length < 8)){
      setErrorMessage('Password must be at least 8 characters')
      return false
    }

    return true
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if(validateForm()){
      // Set loading state
      setRequesting(true)
      if(errorMessage !== null) setErrorMessage(null)

      /** Activate code below in case API not working */
      // let c = window.confirm('Registration system is not implemented yet. Do you want to continue to homepage?')
      // if (c) history.push('/')

      // Use account service
      createAccount(form, /*typeAccount:*/ 1)
      .then(res => {
        toast.success("Successfully registered!")

        if(noRedirect){
          dispatch(setPopupContent('login'))
        } else {
          history.push('/login')
        }
      })
      .catch(err => {
        setErrorMessage(err)
      })
      .then(() => setRequesting(false))
    } else {
      setRequesting(false)
    }
  }

  return (
    <form className={`lg:w-11/12 ${className}`} onSubmit={handleSubmit}>
      <InputRef
        ref={nameField}
        name="name"
        placeholder={translation.AUTH.full_name[language.name]}
        className="w-full mb-3"
        autoComplete="name"
        onChange={(e) => {e.persist(); updateForm(e)}}
        required
      />
      <Input
        name="email"
        placeholder={translation.AUTH.email[language.name]}
        className="w-full mb-3"
        type="email"
        autoComplete="username"
        onChange={(e) => {e.persist(); updateForm(e)}}
        required
      />
      {/* <Input
        name="phone"
        placeholder="Phone"
        className="w-full mb-3"
        onChange={(e) => {e.persist(); updateForm(e)}}
        required
      /> */}
      <div className="mb-5 lg:mb-8">
        <InputPassword
          name="password"
          placeholder={translation.AUTH.password[language.name]}
          className="w-full lg:p-4"
          autoComplete="current-password"
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
        />
      </div>

      <ButtonSecondary
        thin={isMobile}
        disabled={requesting}
        isLoading={requesting}
      >
        {translation.GENERAL.register[language.name]}
      </ButtonSecondary>

      {errorMessage && (
        <AlertError
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}
    </form>
  );
}

export { Form }
